// Datos canónicos del negocio. Importar desde aquí en lugar de hardcodear.

export const SITE = {
  name: "Vega Reparaciones",
  legalName: "Vega Reparaciones",
  shortDescription:
    "Servicio técnico certificado a domicilio en Bogotá. Calentadores, estufas, hornos, plomería y gas. Atención 24/7.",
  longDescription:
    "Más de 15 años reparando calentadores, estufas, hornos, sistemas de gas, plomería y reparaciones locativas en Bogotá y Cundinamarca. Técnicos certificados por el SENA, atención 24/7, repuestos originales y garantía por escrito.",
  url: "https://vegareparaciones.com",
  ogImage: "/og-image.png",
  phone: "+573209270403",
  phonePretty: "+57 320 927 0403",
  whatsappNumber: "573209270403",
  whatsappLink:
    "https://wa.me/573209270403?text=" +
    encodeURIComponent(
      "Hola Vega Reparaciones, necesito información sobre un servicio técnico."
    ),
  serviceArea: "Bogotá D.C. y Cundinamarca",
  hours: "24 horas / 7 días",
  yearsOfExperience: 15,
  certifications: ["SENA", "Técnicos certificados en gas natural y GLP"],
  brands: ["Haceb", "Mabe", "Centrales", "Bosch", "Whirlpool", "LG", "Samsung"],
  social: {
    googleReviews: "",
  },
  /** ID de medición de Google Analytics 4 (G-XXXXXXXXXX). Vacío = desactivado. */
  gaMeasurementId: "G-1YRHHTBJ3N",
} as const;

export const NAV_LINKS = [
  { href: "#hero", label: "Inicio" },
  { href: "#servicios", label: "Servicios" },
  { href: "#nosotros", label: "Nosotros" },
  { href: "#contacto", label: "Contacto" },
] as const;
